import { render, staticRenderFns } from "./ProductTagForm.vue?vue&type=template&id=c8fc3f28&scoped=true&"
import script from "./ProductTagForm.vue?vue&type=script&lang=js&"
export * from "./ProductTagForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagForm.vue?vue&type=style&index=0&id=c8fc3f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fc3f28",
  null
  
)

export default component.exports